import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AssetManagement,AssetSourceConfigurationItem } from '@aptsi-types';
import { environment } from '@env';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandlingService } from 'src/app/shared/errorHandling/errorHandling.service';
import { API_ENDPOINTS } from 'src/app/features/asset-management/asset-management-api-endpoints';


@Injectable({
  providedIn: 'root'
})
export class DataAssetSourceService {
  private readonly dataAssetSourceUrl = environment.apiUrl;

  constructor(private http: HttpClient, private errorHandlingService: ErrorHandlingService) { }

    FetchDataAssetSources(currentPage: number): Observable<AssetManagement[]> {
    return this.http.post<AssetManagement[]>(`${this.dataAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.FETCH_DATA_ASSET_SOURCES}`, { currentPage })
      .pipe(
        map(response => response),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

    FetchDataAssetSourcesSearch( currentPage: number, searchText: String, filterByHeader: String): Observable<AssetManagement[]> {
      return this.http.post<AssetManagement[]>(`${this.dataAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.FETCH_DATA_ASSET_SOURCES_SEARCH}`, { currentPage, searchText, filterByHeader })
        .pipe(
          map(response => response),
          catchError(error => this.errorHandlingService.handleError(error))
        );
    }

  TestAssetSourceConnection(
    assetSource: string,
    url: string,
    connectionDetails: AssetSourceConfigurationItem[]
  ): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${this.dataAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.TESTASSETSOURCECONNECTION}`,
      {
        assetSource,
        url,
        connectionDetails
      }
    ).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }



  // ------------------------------------------------------------------
  // 1. Import Assets during DATA Asset Source Setup
  // ------------------------------------------------------------------
  ImportDataAssetsDuringSetup(
    organizationId: string,
    assetSourceName: string,
    assetSourceType: string,
    assetSource: string,
    importedBy: string,
    url: string,
    connectionDetails: AssetSourceConfigurationItem[],
    importedByKeycloakId: string
  ): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${this.dataAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.IMPORT_DATA_ASSETS_DURING_SETUP}`,
      {
        organizationId,
        assetSourceName,
        assetSourceType,
        assetSource,
        importedBy,
        url,
        connectionDetails,
        importedByKeycloakId
      }
    ).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }


  // ------------------------------------------------------------------
  // 2. Read Imported Assets from Staging Table (with pagination)
  // ------------------------------------------------------------------
  ReadDataAssetsFromStagingTable(
    importedByKeycloakId: string,
    assetSourceName: string
  ): Observable<AssetManagement[]> {
    return this.http.post<AssetManagement[]>(
      `${this.dataAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.READ_DATA_ASSETS_FROM_STAGING_TABLE}`,
      {
        importedByKeycloakId,
        assetSourceName
      }
    ).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }


  // ------------------------------------------------------------------
  // 3. Complete DATA Asset Capture / Setup
  // ------------------------------------------------------------------
  CompleteDataAssetCapture(
    assetSourceName: string,
    assetType: string,
    assetSourceType: string,
    assetSource: string,
    organizationId: string,
    url: string,
    assetSourceConfigurationAttributeDTOs: AssetSourceConfigurationItem[],
    isAssetImport: string,
    importedByKeycloakId: string
  ): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${this.dataAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.COMPLETE_DATA_ASSET_SETUP}`,
      {
        assetSourceName,
        assetType,
        assetSourceType,
        assetSource,
        organizationId,
        url,
        assetSourceConfigurationAttributeDTOs,
        isAssetImport,
        importedByKeycloakId
      }
    ).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }


  // ------------------------------------------------------------------
  // 4. Update DATA Asset Capture / Setup
  // ------------------------------------------------------------------
  UpdateDataAssetSourceDetails(
    assetSourceId: string,
    assetSourceName: string,

  ): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${this.dataAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.UPDATE_DATA_ASSET_SOURCE_DETAILS}`,
      {
        assetSourceId,
        assetSourceName

      }
    ).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }


  FetchDataAssetSourceDetails(assetSourceId: string): Observable<AssetManagement> {
    return this.http.post<AssetManagement>(`${this.dataAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.FETCH_DATA_ASSET_SOURCE_DETAILS}`, { assetSourceId })
      .pipe(
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

  deleteAssetSource(assetSourceId: string): Observable<AssetManagement> {
    return this.http.post<AssetManagement>(`${this.dataAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.DELETE_ASSETSOURCE}`, { assetSourceId })
      .pipe(
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

UpdateDataAssetSourceConnectionDetails(
  assetSourceId: string,
  url: string,
  assetSourceConfigurationAttributeDTOs: AssetSourceConfigurationItem[]
): Observable<{ message: string }> {
  return this.http.post<{ message: string }>(
    `${this.dataAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.UPDATE_DATA_ASSET_SOURCE_CONNECTION_DETAILS}`,
    {
      assetSourceId,
      url,
      assetSourceConfigurationAttributeDTOs
    }
  ).pipe(
    catchError(error =>
      this.errorHandlingService.handleError(error)
    )
  );
}

  fetchDATAAssetSourceConnectionDetails(assetSourceId: string): Observable<AssetManagement> {
    return this.http.post<AssetManagement>(`${this.dataAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.FETCH_DATA_ASSET_SOURCE_CONNECTION_DETAILS}`, { assetSourceId })
      .pipe(
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }


  CompleteDataAssetCaptureFromFIle(
    assetSourceName: string,
    assetType: string,
    assetSourceType: string,
    assetSource: string,
    organizationId: string,
    isAssetImport: string,
    importedByKeycloakId: string
  ): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${this.dataAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.COMPLETE_DATA_ASSET_SETUP_USING_FILE}`,
      {
        assetSourceName,
        assetType,
        assetSourceType,
        assetSource,
        organizationId,
        isAssetImport,
        importedByKeycloakId
      }
    ).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }

  importDataAssetsFromFileDuringSetup(
    file: File,
    organizationId: string,
    assetSourceName: string,
    assetSourceType: string,
    assetSource: string,
    importedBy: string,
    importedByKeycloakId: string
  ): Observable<{ message: string }> {
    const formData = new FormData();
    formData.append("file", file, file.name);
    formData.append("organizationId", organizationId);
    formData.append("assetSourceName", assetSourceName);
    formData.append("assetSourceType", assetSourceType);
    formData.append("assetSource", assetSource);
    formData.append("importedBy", importedBy);
    formData.append("importedByKeycloakId", importedByKeycloakId);
    return this.http.post<{ message: string }>(
      `${this.dataAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.IMPORT_DATA_ASSETS_FROM_FILE_DURING_SETUP}`,
      formData
    ).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }


    ImportDataAssetsFromFile(
    file: File,
    assetSourceId: string
  ): Observable<{ message: string }> {
    const formData = new FormData();
    formData.append("file", file, file.name);
    formData.append("assetSourceId", assetSourceId);
    return this.http.post<{ message: string }>(
      `${this.dataAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.IMPORT_DATA_ASSETS_FROM_FILE}`,
      formData
    ).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }


  FetchDataAssetsFromFile(assetSourceId: string): Observable<AssetManagement> {
    return this.http.post<AssetManagement>(
      `${this.dataAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.FETCH_DATA_ASSETS_FROM_FILE}`,
      {
        assetSourceId
      }
    ).pipe(
      catchError(error =>
        this.errorHandlingService.handleError(error)
      )
    );
  }





createManualDataAsset(
  organizationId: string,
  name: string,
  description: string,
  status: string,
  assetTechnicalName: string,
  qualifiedName: string,
  creationTimestamp: string,
  createdBy: string,
  lastModifiedTimestamp: string,
  lastModifiedBy: string,
  entityVersion: string,
  entityStatus: string,
  collectionId: string,
  classificationName: string,
  upstreamAssetRelationships: string,
  importedAt: string,
  uniqueIdentifier: string,
  importedBy: string,
  importedByKeycloakId: string
): Observable<AssetManagement> {
  return this.http.post<AssetManagement>(
    `${this.dataAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.CREATE_MANUAL_DATA_ASSET}`,
    {
      organizationId,
      name,
      description,
      status,
      assetTechnicalName,
      qualifiedName,
      creationTimestamp,
      createdBy,
      lastModifiedTimestamp,
      lastModifiedBy,
      entityVersion,
      entityStatus,
      collectionId,
      classificationName,
      upstreamAssetRelationships,
      importedAt,
      uniqueIdentifier,
      importedBy,
      importedByKeycloakId
    }
  ).pipe(
    catchError(error =>
      this.errorHandlingService.handleError(error)
    )
  );
}


  updateManualDataAsset(
    dataAssetId: string,
     organizationId: string,
  name: string,
  description: string,
  status: string,
  assetTechnicalName: string,
  qualifiedName: string,
  creationTimestamp: string,
  createdBy: string,
  lastModifiedTimestamp: string,
  lastModifiedBy: string,
  entityVersion: string,
  entityStatus: string,
  collectionId: string,
  classificationName: string,
  upstreamAssetRelationships: string,
  importedAt: string,
  uniqueIdentifier: string,
  importedBy: string,
  importedByKeycloakId: string
  ): Observable<AssetManagement> {
    return this.http.post<AssetManagement>(
      `${this.dataAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.UPDATE_MANUAL_DATA_ASSET}`,
      {
        dataAssetId,
       organizationId,
      name,
      description,
      status,
      assetTechnicalName,
      qualifiedName,
      creationTimestamp,
      createdBy,
      lastModifiedTimestamp,
      lastModifiedBy,
      entityVersion,
      entityStatus,
      collectionId,
      classificationName,
      upstreamAssetRelationships,
      importedAt,
      uniqueIdentifier,
      importedBy,
      importedByKeycloakId
      }
    ).pipe(
      catchError(error =>
        this.errorHandlingService.handleError(error)
      )
    );
  }

  getManualDataAsset(dataAssetId: string): Observable<AssetManagement> {
    return this.http.post<AssetManagement>(
      `${this.dataAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.GET_MANUAL_DATA_ASSET}`,
      {
        dataAssetId
      }
    ).pipe(
      catchError(error =>
        this.errorHandlingService.handleError(error)
      )
    );
  }


  ImportDataAssetsByAssetSource(
    assetSourceId: string,

  ): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${this.dataAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.IMPORT_DATA_ASSETS_BY_ASSET_SOURCE_ID}`,
      {
        assetSourceId,

      }
    ).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }

    FetchDataAssetsByAssetSourceID(
      assetSourceId: string,
      currentPage: number
    ): Observable<AssetManagement[]> {
      return this.http.post<AssetManagement[]>(
        `${this.dataAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.FETCH_DATA_ASSETS_BY_ASSET_SOURCE_ID}`,
        { assetSourceId, currentPage }
      ).pipe(
        map(response => response),
        catchError(error =>
          this.errorHandlingService.handleError(error)
        )
      );
    }
  
    FetchDataAssetsByAssetSourceIDSearch(assetSourceId: string, currentPage: number, searchText: String, filterByHeader: String): Observable<AssetManagement[]> {
      return this.http.post<AssetManagement[]>(`${this.dataAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.SEARCH_DATA_ASSETS_BY_ASSET_SOURCE_ID}`, { assetSourceId, currentPage, searchText, filterByHeader })
        .pipe(
          map(response => response),
          catchError(error => this.errorHandlingService.handleError(error))
        );
    }


}

